import { STORAGE_KEYS } from "~/libs/storage-keys";
import { useLocalForage } from "~served/ui-comps/hooks/use-local-forage";

export const useDigitalMenuNotificationLocationIds = () =>
	useLocalForage<string[] | null>(
		STORAGE_KEYS.DIGITAL_MENU_NOTIFICATION_LOCATION_IDS,
		null,
	);

export const isDigitalMenuOrder = (
	order:
		| {
				source?: string | null;
				status?: string | null;
		  }
		| null
		| undefined,
) => order?.source === "qr" && order?.status === "placed";

export const shouldNotifyForDigitalMenuLocation = (
	locationId: string | null | undefined,
	selectedLocationIds: string[] | null | undefined,
) => {
	if (!selectedLocationIds?.length) return true;
	if (!locationId) return false;

	return selectedLocationIds.includes(locationId);
};

export const shouldNotifyForDigitalMenuOrder = (
	order:
		| {
				source?: string | null;
				status?: string | null;
				location?: string | null;
				_location?: { _id?: string | null } | null;
		  }
		| null
		| undefined,
	selectedLocationIds: string[] | null | undefined,
) => {
	if (!isDigitalMenuOrder(order)) return false;

	return shouldNotifyForDigitalMenuLocation(
		order?._location?._id ?? order?.location,
		selectedLocationIds,
	);
};
